export default class Field{
    id;
    name;
    constructor(data){
        this.id=data?.id;
        this.name=data?.name;
    }
}